import { ReduxService } from 'dashboard-services/services';

import { basicDataStorageCreatorActions as basicActions, saveDialogDataStorageCreatorActions as saveActions } from 'actions/modules/dataStorage/creator';

export const saveDialogInitialState = {
  groupName: undefined,
  isOpen: false,
  name: undefined,

  onClose: undefined,
  onSubmit: undefined
}

export default (state = saveDialogInitialState, action) => {
  switch (action.type) {
    case saveActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicActions.CLEAR:
      return saveDialogInitialState;
    default:
      return state; 
  }
}